module.exports = __webpack_public_path__ + "static/startingstyle-a1668b6822d09e2f573cc7aa1d2b7a10.mp4";